/* tslint:disable */
/* eslint-disable */
/**
 * Supply API Gateway
 * A REST API responsible to serve and compose all supply-related data available at Taster
 *
 * The version of the OpenAPI document: 1.63
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class ClaimsApi extends runtime.BaseAPI {
    /**
     * Send claim to Supplier
     */
    createClaimRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.purchaseUuid === null || requestParameters.purchaseUuid === undefined) {
                throw new runtime.RequiredError('purchaseUuid', 'Required parameter requestParameters.purchaseUuid was null or undefined when calling createClaim.');
            }
            const queryParameters = {};
            if (requestParameters.purchaseUuid !== undefined) {
                queryParameters['purchase_uuid'] = requestParameters.purchaseUuid;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["purchase-orders:write"]);
            }
            const response = yield this.request({
                path: `/create-claim`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Send claim to Supplier
     */
    createClaim(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.createClaimRaw(requestParameters, initOverrides);
        });
    }
}
